//#region recipes/leftbar/general_row/general_row_constants.js
var e = {
	INBOX: "inbox",
	CONTACTS: "contacts",
	CHANNELS: "channels",
	THREADS: "threads",
	LAUNCHPAD: "launchpad",
	LOCKED_CHANNEL: "locked channel",
	CONTACT_CENTER: "contact center",
	QUICK_START: "quick start",
	COACHING_GROUP: "coaching group",
	COACHING_CENTER: "coaching center",
	DIALBOT: "dialbot",
	ASSIGNED: "assigned",
	DIGITAL: "digital",
	SCHEDULED: "scheduled"
}, t = {
	"magenta-100": "d-recipe-leftbar-general-row__contact-center--magenta-100",
	"magenta-200": "d-recipe-leftbar-general-row__contact-center--magenta-200",
	"magenta-300": "d-recipe-leftbar-general-row__contact-center--magenta-300",
	"magenta-400": "d-recipe-leftbar-general-row__contact-center--magenta-400",
	"green-200": "d-recipe-leftbar-general-row__contact-center--green-200",
	"green-500": "d-recipe-leftbar-general-row__contact-center--green-500",
	"gold-300": "d-recipe-leftbar-general-row__contact-center--gold-300",
	"purple-100": "d-recipe-leftbar-general-row__contact-center--purple-100",
	"purple-300": "d-recipe-leftbar-general-row__contact-center--purple-300",
	"purple-600": "d-recipe-leftbar-general-row__contact-center--purple-600",
	"black-300": "d-recipe-leftbar-general-row__contact-center--black-300"
}, n = "If type is contact center, color must be oneof the following:" + Object.keys(t).join(", "), r = ["300", "200"], i = {
	LEFTBAR_GENERAL_ROW_TYPES: e,
	LEFTBAR_GENERAL_ROW_CONTACT_CENTER_COLORS: t,
	LEFTBAR_GENERAL_ROW_CONTACT_CENTER_VALIDATION_ERROR: n,
	LEFTBAR_GENERAL_ROW_ICON_SIZES: r
};
//#endregion
export { t as LEFTBAR_GENERAL_ROW_CONTACT_CENTER_COLORS, n as LEFTBAR_GENERAL_ROW_CONTACT_CENTER_VALIDATION_ERROR, r as LEFTBAR_GENERAL_ROW_ICON_SIZES, e as LEFTBAR_GENERAL_ROW_TYPES, i as default };

//# sourceMappingURL=general-row-constants.js.map